import { useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { queryClient } from '@/queryClient';
import { resetLoginStore, useLoginStore } from '../store';

type LogoutSyncRouter = ReturnType<typeof useRouter>;

function onStorage(router: LogoutSyncRouter, event: StorageEvent): void {
    const storageKey = useLoginStore.persist.getOptions().name;
    if (
        !storageKey ||
        event.storageArea !== window.localStorage ||
        (event.key !== storageKey && event.key !== null)
    ) {
        return;
    }

    // Lê o valor atual para não aplicar um logout anterior a um novo login.
    const persisted = window.localStorage.getItem(storageKey);
    if (persisted) {
        let saved: { state?: { login?: unknown } };

        try {
            saved = JSON.parse(persisted);
        } catch {
            return;
        }

        if (saved?.state?.login !== null) {
            return;
        }
    }

    if (!useLoginStore.getState().login) {
        return;
    }

    resetLoginStore();
    queryClient.clear();

    const pathname = router.state.location.pathname;
    if (pathname === '/a' || pathname.startsWith('/a/')) {
        void router.navigate({
            ignoreBlocker: true,
            replace: true,
            to: '/auth/login',
        });
    }
}

export function useLogoutSync(): void {
    const router = useRouter();

    useEffect(() => {
        const listener = onStorage.bind(null, router);
        window.addEventListener('storage', listener);

        return () => window.removeEventListener('storage', listener);
    }, [router]);
}
